export const previewIconStyles = {
  root: {
    height: "20px",
    width: "20px",
  },
};

export const textStylesForIcon = {
  margin: "0px 1px",
  textOverflow: "ellipsis",
  overflowX: "hidden",
  overflowY: "hidden",
};
